export default __webpack_public_path__ + "static/media/Mark-2-HUD-Header.3bfc3c61.jpg";